<p-dialog #addUserDialog [contentStyle]="{'max-height':'85vh'}" [focusOnShow]="false" width="800" minHeight="600"
  [closable]="false" [blockScroll]="true" [modal]="true" [draggable]="false" [baseZIndex]="500"
  header="Cancel Short Code Lease" [(visible)]="display" (onHide)="cancel()">
  <form #transferForm="ngForm">
    <div class="mb-2 ms-3 me-5">
     
      <div class="mt-4">
     
        <div class="row mt-1 ms-0">
          <div class="row ms-0 term-align">
         <p>{{errorMessage}}</p> 
          </div>
        </div>
      </div>
    </div>

  </form>
  <p-footer>
    <div class="d-flex justify-content-end me-2">
      <button i18n id="screject" class="btn btn-secondary" type="button" (click)="closeDialog()">Ok</button>
    </div>
  </p-footer>
</p-dialog>